import { PATH_CHEWS_DETAILS } from '@farmersdog/constants/paths';

import { ChewQueryParams } from '@/account/treats';

export function formatChewsPdpURL(chewLength: string) {
  return `${PATH_CHEWS_DETAILS}?${ChewQueryParams.chewLength}=${chewLength}`;
}
